document.addEventListener('DOMContentLoaded', function() { 
    // FILTERED POSTS FUNCTIONALITY
    const filteredPostsContainer = document.getElementById('filtered-posts-container');
    if (filteredPostsContainer) {
        let FilterPostsParent = document.querySelector('.filtered-posts');
        let totalPages = filteredPostsContainer.dataset.totalpages ?? 1;
        let currentPage = filteredPostsContainer.dataset.currentpage ?? 1;
        const postsPerPage = filteredPostsContainer.dataset.offset; // Set the number of posts to display per page
        
        // Load More button event listener
        const loadMoreButton = document.getElementById('load-more-button');
        if (loadMoreButton) {
            loadMoreButton.addEventListener('click', function () {
                this.innerHTML = 'Loading...';
                if (currentPage < totalPages) {
                    currentPage++;
                    fetchFilteredPosts(currentPage);
                }
            });
        }
        
        updatePaginationButtons(totalPages);

        // Form submission event
        let formFilters = document.getElementById('filter-form');
        if (formFilters) {
            // Event listener for form submission
            document.getElementById('filter-form').addEventListener('submit', function (event) {
                event.preventDefault();
                currentPage = 1; // Reset current page to 1 when filters are applied
                filteredPostsContainer.innerHTML = ''; // Clear previous results
                
                // Show a loading message while fetching posts
                filteredPostsContainer.innerHTML = '<p class="loading-message">Searching...</p>';

                fetchFilteredPosts(currentPage);
            });
        }

        // Function to display filtered posts
        function fetchFilteredPosts(currentPage) {
            const offset = (currentPage - 1) * postsPerPage;
            const dateFilter = document.getElementById('date-filter');
            const categoryFilter = document.getElementById('category-filter');
            const tagFilter = document.getElementById('tag-filter');
            const searchFilter = document.getElementById('search-filter');

            var dateFilterValue = dateFilter ? dateFilter.value : '';
            var categoryFilterValue = categoryFilter ? categoryFilter.value : '';
            var tagFilterValue = tagFilter ? tagFilter.value : '';
            var searchValue = searchFilter ? searchFilter.value : '';
            
            var apiUrl = '/wp-json/wp/v2/posts';
            apiUrl += `?_embed&per_page=${postsPerPage}&offset=${offset}&page=${currentPage}&orderby=date&order=desc`;
            
            if (dateFilterValue) {
                var yearFilterValue = dateFilterValue.substring(3, 7);
                var monthFilterValue = dateFilterValue.substring(0, 2);

                apiUrl += `&filter[year]=${yearFilterValue}&filter[monthnum]=${monthFilterValue}`;
            }
            if (categoryFilterValue) {
                apiUrl += `&categories=${categoryFilterValue}`;
            }

            if (tagFilterValue) {
                apiUrl += `&tags=${tagFilterValue}`;
            }

            if (searchValue){
				apiUrl += `&search=${searchValue}`;
			}
            
            // Fetch filtered posts from WP REST API
            fetch(apiUrl)
                .then(function (response) {
                    return response.json().then(posts => ({ posts, totalPages: parseInt(response.headers.get('X-WP-TotalPages')) }));
                })
                .then(function ({posts, totalPages}) {
                    // Remove the loading message
                    document.querySelector('.loading-message')?.remove();
                    
                    displayFilteredPosts(posts, totalPages);
                    if (currentPage >= totalPages) {
                        loadMoreButton.style.display = 'none'; // Hide the Load More button if there are no more pages
                    } else {
                        loadMoreButton.innerHTML = 'Load More'; // Reset the button text
                    }
                })
                .catch(error => console.error(error));
        }

        // Function to display filtered posts
        function displayFilteredPosts(posts, totalPages) {
            if (posts.length === 0) {
                filteredPostsContainer.classList.add('no-posts');
                filteredPostsContainer.innerHTML = '<div class="wp-block-group" style="grid-column-start: 1;grid-column-end:-1;"><hr class="wp-block-separator" style="margin-top: var(--wp--preset--spacing--70); margin-bottom: var(--wp--preset--spacing--70)"><p>No posts found.</p></div>';
               
                // Animate the posts in
                FilterPostsParent.style.opacity = 1;

                return;

            }

            var postsHTML = posts.map(function (post) {
                var postExcerpt = '';
                var postMeta = '';

                // Parse the date string into a Date object
                var dateObject = new Date(post.date);

                // Format date as F j, Y
                var formattedDate = dateObject.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

                postMeta = `<div class="wp-block-post-meta"><time class="wp-block-post-date">${formattedDate}</time></div>`;
                postExcerpt = `<p class="wp-block-post-excerpt" style="margin-top: var(--wp--preset--spacing--20)"><p class="wp-block-post-excerpt__excerpt">${post.excerpt.rendered}</p><p class="wp-block-post-excerpt__more-text"><a class="wp-block-post-excerpt__more-link" href="${post.link}">Read More</a></p></div>`;

                return `<div id="post-${post.id}" class="filtered-post wp-block-post">
                        <hr class="wp-block-separator" style="margin-top: var(--wp--preset--spacing--70); margin-bottom: var(--wp--preset--spacing--70); border-color: var(--wp--preset--color--medium-gray)">
                                ${postMeta}
                                <h3 class="wp-block-post-title" style="margin-top: var(--wp--preset--spacing--40);">
                                    <a href="${post.link}">${post.title.rendered}</a>
                                </h3>
                                ${postExcerpt}
                            </div>
                        </div>
                    </div>
                `;
            }).join('');

            // Append the posts to the filteredPostsContainer with existing posts and animate in 
            filteredPostsContainer.innerHTML += postsHTML;

            // Animate the posts in
            FilterPostsParent.style.opacity = 1;

            // Update pagination buttons based on the current page and total pages
            updatePaginationButtons(totalPages);
        }

        // Function to update pagination buttons based on current page and total pages
        function updatePaginationButtons(totalPages) {
            const loadMoreButton = document.getElementById('load-more-button');
            // Disable Load More button if there are no more pages to load
            if (currentPage >= totalPages) {
                loadMoreButton.style.display = 'none';
            } else {
                loadMoreButton.style.display = 'block';
            }
        }
    }

}, false);
